import * as React from 'react'

import { EngagementTabsDocument } from 'generated/resources/graphql'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/engagement/pages/settings/RootPage'))

const engagementSettingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.engagement.path,
      element: <RootPage />,
      handle: {
        meta: ({ watchQuery, session, navigate }) => {
          return watchQuery({
            query: EngagementTabsDocument,
            variables: {
              companyId: session.company.id,
            },
          }).map(({ data }) => {
            const settingsManage = data?.engagement?._policies.settingsManage.can
            if (!settingsManage) {
              navigate(navigation.settings.fullPath())
            }

            return getSettingPageMeta(navigation, 'engagement')
          })
        },
      },
    },
  ]
}

export default engagementSettingsRoutes
